import { ROUTE_PATH_ADMIN_SETTINGS } from 'src/modules/3rd-party-management/constants';

export const settingsPath = `${ROUTE_PATH_ADMIN_SETTINGS}?tab=email-settings`;
export const settingsQueryKey = 'tp-fetch-mailer-settings';
